import io from 'socket.io-client'
import { urlapi } from '../backend/data'
let socket = io(urlapi)
export default  socket